import __request__ from "routing/request";
export function create(JSONbody) {
  return __request__("POST", "/views", JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function views(sort = "title", page = 1, per_page = 50, order = "asc", query) {
  return __request__("GET", "/views", null, { "page": page, "per_page": per_page, "sort": sort, "order": order, "query": query }, {
    "Accept": ["application/json"]
  });
}
export function bulkDelete(Entitiestoremove) {
  return __request__("POST", "/views/bulk_delete", Entitiestoremove, {}, {
    "Accept": ["application/json"]
  });
}
export function get(id) {
  return __request__("GET", `/views/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function update(JSONbody, id) {
  return __request__("PUT", `/views/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function remove(id) {
  return __request__("DELETE", `/views/${id}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function duplicate(JSONbody, id) {
  return __request__("POST", `/views/${id}`, JSONbody, {}, {
    "Accept": ["application/json"]
  });
}
export function setDefault(id) {
  return __request__("PUT", `/views/${id}/default`, null, {}, {
    "Accept": ["application/json"]
  });
}
